import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box, Button, Drawer } from '@mui/material';
import EmptySearchResults from '../../components/EmptySearchResults';

import useAnalytics from '../../hooks/useAnalytics';
import { TRACK } from '../../constants/analytics';
import {
  ERROR_BOUNDARY_TYPES,
  Error,
  useErrorBoundaryConfigurations,
} from '../../features/ErrorBoundary';
import { ErrorHelpers } from '../../helpers';
import useBreakpoint from '../../hooks/useBreakpoint';
import { BACK } from '../../constants/strings';
import { Sidebar } from './components';

const Track = () => {
  const location = useLocation();
  const getErrorBoundaryConfig = useErrorBoundaryConfigurations();
  const error = location.state?.error;
  const isSmallScreen = useBreakpoint('md');
  const [isDrawerOpen, setDrawerOpen] = useState(false);

  const { setInterfaceId, Trackable } = useAnalytics();

  useEffect(() => {
    setInterfaceId(TRACK.INTERFACE_ID);
  }, []);

  return (
    <Trackable loadId={TRACK.LOAD}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { md: 'row' },
          height: '100%',
          flexGrow: 1,
        }}
      >
        {!isSmallScreen ? (
          <>
            <Sidebar setDrawerOpen={setDrawerOpen} />
            {error ? (
              <>
                {ErrorHelpers.isNotFoundError(error) ? (
                  <EmptySearchResults sx={{ width: '100%' }} />
                ) : (
                  <Error
                    config={getErrorBoundaryConfig[
                      ERROR_BOUNDARY_TYPES.WE_HAVE_A_LITTLE_PROBLEM
                    ](error.message)}
                  />
                )}
              </>
            ) : (
              <Outlet />
            )}
          </>
        ) : (
          <>
            <Sidebar setDrawerOpen={setDrawerOpen} />
            <Drawer
              open={isDrawerOpen}
              anchor='right'
              PaperProps={{
                sx: { width: '100%' },
              }}
            >
              {error ? (
                <>
                  {ErrorHelpers.isNotFoundError(error) ? (
                    <EmptySearchResults
                      sx={{ width: '100%', m: '50% auto' }}
                      button={
                        <Button
                          variant={'contained'}
                          onClick={() => setDrawerOpen(false)}
                        >
                          {BACK}
                        </Button>
                      }
                    />
                  ) : (
                    <Error
                      config={getErrorBoundaryConfig[
                        ERROR_BOUNDARY_TYPES.WE_HAVE_A_LITTLE_PROBLEM
                      ](error.message)}
                    />
                  )}
                </>
              ) : (
                <Outlet context={setDrawerOpen} />
              )}
            </Drawer>
          </>
        )}
      </Box>
    </Trackable>
  );
};

export default Track;
